/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Prices_IncompleteInputs */

const en_error_prices_incomplete = /** @type {(inputs: Error_Prices_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some lines have no wholesale or retail price.`)
};

/**
* | output |
* | --- |
* | "Some lines have no wholesale or retail price." |
*
* @param {Error_Prices_IncompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_prices_incomplete = /** @type {((inputs?: Error_Prices_IncompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Prices_IncompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_prices_incomplete(inputs)
});